module.exports = __webpack_public_path__ + "img/bg_invite.7987eda2.png";